detailsCurrencyIso